import { Pipe, PipeTransform } from '@angular/core';
import { ReportLogs } from '@app/store/models/certificate.model';
import { ViewFilter } from '../components/routes/action-report/action-report.component';

@Pipe({
    name: 'viewFilter',
    standalone: false
})
export class ViewFilterPipe implements PipeTransform {
  transform(logs: ReportLogs[], type: ViewFilter = 'ALL'): ReportLogs[] {
    if (type !== 'ALL') {
      return logs.filter(log => log.value.result === type);
    } else {
      return logs;
    }
  }
}
